import { defineComponent as _defineComponent } from 'vue'
import { useCourseBuilderStore } from '@/stores/trainings/courseBuilder';
  import { Button } from '@/ui/components/Button';
  import { CourseSection } from '@/entities/trainings';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'TreeToolbar',
  props: {
    section: {
      type: Object as () => CourseSection,
      required: false,
    },
    canAddSection: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  setup(__props) {

const { section } = __props;

  

  const courseBuilderStore = useCourseBuilderStore();

  const onAddSection = (): void => {
    courseBuilderStore.addSection(section);
  };

  const onAddComponent = (): void => {
    courseBuilderStore.addItem(section);
  };

return { __sfc: true,courseBuilderStore, onAddSection, onAddComponent, Button }
}

})